module.exports = __webpack_public_path__ + "media/images/view_profile-5c06be6a67500eddb1f2a3edab943165.jpg";